// Advanced search and filtering schemas

export interface FilterCondition {
  field: string;
  operator:
    | 'equals'
    | 'contains'
    | 'startsWith'
    | 'endsWith'
    | 'greaterThan'
    | 'lessThan'
    | 'between'
    | 'in'
    | 'notIn';
  value: string | number | string[] | number[];
  type: 'text' | 'number' | 'date' | 'select';
}

export interface FilterGroup {
  id: string;
  logic: 'AND' | 'OR';
  conditions: FilterCondition[];
}

export interface AdvancedSearchQuery {
  globalSearch?: string;
  filterGroups: FilterGroup[];
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  dateRange?: {
    field: string;
    start?: string;
    end?: string;
  };
}

export interface SavedSearch {
  id: string;
  name: string;
  query: AdvancedSearchQuery;
  createdAt: string;
  lastUsed?: string;
}

export interface SearchFilterFormData {
  search?: string;
  status?: string;
  type?: string;
  startDate?: string;
  endDate?: string;
  // Advanced fields
  advancedMode?: boolean;
  filterGroups?: FilterGroup[];
  savedSearchId?: string;
}

export interface SearchSuggestion {
  type: 'user' | 'organization' | 'email' | 'field';
  value: string;
  label: string;
  context?: string;
}

export const searchableFields = [
  { value: 'email', label: 'Email', type: 'text' as const },
  { value: 'displayName', label: 'Display Name', type: 'text' as const },
  { value: 'organizationName', label: 'Organization', type: 'text' as const },
  { value: 'credits', label: 'Credits', type: 'number' as const },
  { value: 'status', label: 'Status', type: 'select' as const },
  { value: 'createdAt', label: 'Created Date', type: 'date' as const },
  { value: 'lastLoginAt', label: 'Last Login', type: 'date' as const },
  {
    value: 'usageGenerationsThisMonth',
    label: 'Generations This Month',
    type: 'number' as const,
  },
];

export const operatorsByType = {
  text: [
    { value: 'contains', label: 'Contains' },
    { value: 'equals', label: 'Equals' },
    { value: 'startsWith', label: 'Starts with' },
    { value: 'endsWith', label: 'Ends with' },
  ],
  number: [
    { value: 'equals', label: 'Equals' },
    { value: 'greaterThan', label: 'Greater than' },
    { value: 'lessThan', label: 'Less than' },
    { value: 'between', label: 'Between' },
  ],
  date: [
    { value: 'equals', label: 'On date' },
    { value: 'greaterThan', label: 'After' },
    { value: 'lessThan', label: 'Before' },
    { value: 'between', label: 'Between' },
  ],
  select: [
    { value: 'equals', label: 'Equals' },
    { value: 'in', label: 'In list' },
    { value: 'notIn', label: 'Not in list' },
  ],
};
